import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/user', [
    {
      path: '',
      name: 'user',
      redirect: { name: 'user-list' },
    },
    {
      path: '/list',
      name: 'user-list',
      component: () => import('@/views/user/UserList.vue'),
    },
    {
      path: '/create',
      name: 'user-create',
      component: () => import('@/views/user/UserCreate.vue'),
    },
    {
      path: '/:id(\\d+)',
      name: 'user-edit',
      component: () => import('@/views/user/UserEdit.vue'),
      redirect: { name: 'user-edit-details' },
      children: [
        {
          path: 'details',
          name: 'user-edit-details',
          component: () => import('@/components/user/UserDetails.vue'),
        },
        {
          path: 'permissions',
          name: 'user-edit-permissions',
          component: () => import('@/components/user/UserPermissions.vue'),
        },
      ],
    },
  ]);
};
